import { Target, Phone } from "lucide-react";
import { cn } from "../../../../utils/utils";
import { FILTER_ROLES } from "../../constants/filterPresets";

const RoleSwitch = ({ role, onChange }) => {
  return (
    <div className="inline-flex items-center rounded-full border border-gray-200 bg-white p-0.5 text-[12px] font-medium">
      <button
        onClick={() => onChange?.(FILTER_ROLES.SALES)}
        className={cn(
          "inline-flex items-center gap-1 h-6 px-2 rounded-full transition-colors",
          role === FILTER_ROLES.SALES
            ? "bg-primary text-white"
            : "text-gray-600 hover:text-gray-900",
        )}
        title="Chế độ Sales"
      >
        <Target size={12} />
        Sales
      </button>
      <button
        onClick={() => onChange?.(FILTER_ROLES.CSKH)}
        className={cn(
          "inline-flex items-center gap-1 h-6 px-2 rounded-full transition-colors",
          role === FILTER_ROLES.CSKH
            ? "bg-primary text-white"
            : "text-gray-600 hover:text-gray-900",
        )}
        title="Chế độ CSKH"
      >
        <Phone size={12} />
        CSKH
      </button>
    </div>
  );
};

export default RoleSwitch;
